export class NegativeBoundsError extends Error {
    constructor() {
        super("Bounds cannot be negative");
        this.name = NegativeBoundsError.name;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibmVnYXRpdmUtYm91bmRzLWVycm9yLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL2NvcmUvZ2VvbWV0cnkvYm91bmRzL25lZ2F0aXZlLWJvdW5kcy1lcnJvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLE9BQU8sbUJBQW9CLFNBQVEsS0FBSztJQUM1QztRQUNFLEtBQUssQ0FBQywyQkFBMkIsQ0FBQyxDQUFDO1FBQ25DLElBQUksQ0FBQyxJQUFJLEdBQUcsbUJBQW1CLENBQUMsSUFBSSxDQUFDO0lBQ3ZDLENBQUM7Q0FDRiJ9